import {GreenAreasIcon, IntimateBuildingIcon, SpecialPriceIcon} from "@pg-design/icons-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {OfferType} from "../../offer/types/OfferType";
import {flatsPluralize} from "../../real_estate/constants/flats_pluralize";
import {TagType} from "../../types/TagType";
import {IPropertyTags} from "../components/PropertyDetailTags";
import {IPropertyTag} from "../types/IPropertyTag";

const commercialPlural = pluralize(["lokal użytkowy", "lokale użytkowe", "lokali użytkowych"]);

export const getPropertyTagProps = (tag: IPropertyTag, property: Pick<IPropertyTags["property"], "offer" | "price">) => {
    switch (tag.id) {
        case TagType.INTIMATE_BUILDING: {
            return {
                label: "Kameralny budynek",
                icon: IntimateBuildingIcon,
                value: property.offer.properties
                    ? `${property.offer.properties} ${
                          property.offer.type === OfferType.COMMERCIAL ? commercialPlural(property.offer.properties) : flatsPluralize(property.offer.properties)
                      } w inwestycji`
                    : ""
            };
        }
        case TagType.GREEN_AREAS: {
            return {
                label: "Tereny zielone",
                icon: GreenAreasIcon,
                value: tag.description || tag.name
            };
        }
        case TagType.SPECIAL_PRICE: {
            if (property.price) {
                return {
                    label: "Okazyjna cena",
                    icon: SpecialPriceIcon,
                    value: tag.description || `${numberFormat(property.price)} zł`
                };
            }
            return null;
        }
        default:
            return null;
    }
};
import {GreenAreasIcon, IntimateBuildingIcon, SpecialPriceIcon} from "@pg-design/icons-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {OfferType} from "../../offer/types/OfferType";
import {flatsPluralize} from "../../real_estate/constants/flats_pluralize";
import {TagType} from "../../types/TagType";
import {IPropertyTags} from "../components/PropertyDetailTags";
import {IPropertyTag} from "../types/IPropertyTag";

const commercialPlural = pluralize(["lokal użytkowy", "lokale użytkowe", "lokali użytkowych"]);

export const getPropertyTagProps = (tag: IPropertyTag, property: Pick<IPropertyTags["property"], "offer" | "price">) => {
    switch (tag.id) {
        case TagType.INTIMATE_BUILDING: {
            return {
                label: "Kameralny budynek",
                icon: IntimateBuildingIcon,
                value: property.offer.properties
                    ? `${property.offer.properties} ${
                          property.offer.type === OfferType.COMMERCIAL ? commercialPlural(property.offer.properties) : flatsPluralize(property.offer.properties)
                      } w inwestycji`
                    : ""
            };
        }
        case TagType.GREEN_AREAS: {
            return {
                label: "Tereny zielone",
                icon: GreenAreasIcon,
                value: tag.description || tag.name
            };
        }
        case TagType.SPECIAL_PRICE: {
            if (property.price) {
                return {
                    label: "Okazyjna cena",
                    icon: SpecialPriceIcon,
                    value: tag.description || `${numberFormat(property.price)} zł`
                };
            }
            return null;
        }
        default:
            return null;
    }
};
